import { render, staticRenderFns } from "./ImportFiles.vue?vue&type=template&id=33e1ce9e&scoped=true&"
import script from "./ImportFiles.vue?vue&type=script&lang=js&"
export * from "./ImportFiles.vue?vue&type=script&lang=js&"
import style0 from "./ImportFiles.vue?vue&type=style&index=0&id=33e1ce9e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33e1ce9e",
  null
  
)

export default component.exports